import Swiper from 'swiper/bundle';

export default class Banner {
    private selector: HTMLElement;

    constructor(selector: string) {
        this.selector = document.querySelector(selector);
        if (this.selector) {
            this.init();
        }
    }

    private init() : void {
        new Swiper(this.selector, {
            loop: true,
            speed: 1000,
            centeredSlides: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
}
